// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3pfWO","rootSuccess":"CompleteLink_rootSuccess__1KXBk","rootFailure":"CompleteLink_rootFailure__2meqC","isDisabled":"CompleteLink_isDisabled__wfvY_"};